import React, { useEffect, useRef } from 'react';
import MapView from '../MapView/MapView';
import {NavLink,useHistory, Redirect,withRouter} from 'react-router-dom';
 
//Start UsersDashboard component code ...
const UsersDashboardV2 = (props) => { 
    const [login, setLogin] = React.useState(false);
    const [clicked, setClicked] = React.useState(true);
    useEffect(
        () => {
            if(props.location.state) {
                setClicked(props.location.state);
                setLogin(props.location.state.newLogin);
            }           
        },[props])
    return <>
    
  <MapView newLogin = {login} clicked = {clicked}/>  
    </>   

}

export default withRouter(UsersDashboardV2)
//Start UsersDashboard component code ...
